export default "__VITE_ASSET__DGmM0bo3__"